import Router from "vue-router";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};
import Vue from "vue";
Vue.use(Router);

const router = new Router({
  // base:'/wxh5/utils',
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/views/home"),
      name: "home",
      meta: {
        title: "首页",
      },
    },
    {
      path: "/home_aboutUs",
      component: () => import("@/views/aboutUs"),
      name: "aboutUs",
      meta: {
        title: "关于我们",
      },
      children: [
        {
          path: "/home_aboutUs/brandStory",
          component: () => import("@/views/aboutUs/children/brandStory"),
          name: "brandStory",
          meta: {
            title: "品牌故事",
          },
        },
        {
          path: "/home_aboutUs/brandIntro",
          component: () => import("@/views/aboutUs/children/brandIntro"),
          name: "brandIntro",
          meta: {
            title: "品牌介绍",
          },
        },
      ],
    },
    {
      path: "/home_ggFamily",
      component: () => import("@/views/ggFamily"),
      name: "ggFamily",
      meta: {
        title: "果果家族",
      },
      children: [
        {
          path: "/home_ggFamily/box",
          component: () => import("@/views/ggFamily/children/box"),
          name: "box",
          meta: {
            title: "孕爸宝盒",
          },
        },
        {
          path: "/home_ggFamily/app",
          component: () => import("@/views/ggFamily/children/app"),
          name: "app",
          meta: {
            title: "果果孕育APP",
          },
        },
        {
          path: "/home_ggFamily/weChatApp",
          component: () => import("@/views/ggFamily/children/weChatApp"),
          name: "weChatApp",
          meta: {
            title: "果果孕育小程序",
          },
        },
      ],
    },
    {
      path: "/home_news",
      component: () => import("@/views/news"),
      name: "news",
      meta: {
        title: "品牌动态",
      },
    },
    {
      path: "/home_knowledgeBase",
      component: () => import("@/views/knowledgeBase"),
      name: "knowledgeBase",
      meta: {
        title: "知识库",
      },
      
    },
    {
      path: "/home_knowledgeBase/detail/:id",
      component: () => import("@/views/knowledgeBase/detail"),
      name: "knowledgeBaseDetail",
      meta: {
        title: "知识详情",
      },
      hidden:true,
      props:true
    },
   
    {
      path: "/home_contactUs",
      component: () => import("@/views/contactUs"),
      name: "contactUs",
      meta: {
        title: "联系我们",
      },
      children: [
        {
          path: "/home_contactUs/joinUs",
          component: () => import("@/views/contactUs/children/joinUs"),
          name: "joinUs",
          meta: {
            title: "加入我们",
          },
        },
        {
          path: "/home_contactUs/joinUs",
          component: () => import("@/views/contactUs/children/addressPhone"),
          name: "addressPhone",
          meta: {
            title: "地址电话",
          },
        },
      ],
    },
  ],
  // scrollBehavior: () => ({
  //     y: 0
  // })
});
router.beforeEach((to, from, next) => {
  document.title = /* "果果孕育-" + to.meta.title */"玖盟健康";
  next();
});
router.afterEach((to, from) => {
  let bodySrcollTop = document.body.scrollTop;
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0;
    return;
  }
  let docSrcollTop = document.documentElement.scrollTop;
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0;
  }
});
export default router;
